import {
  ArenaVinci01,
  ArenaVinci02,
  ArenaVinci03,
  ArenaVinci04,
  ArenaVinci05,
  ArenaVinci06,
  ArenaVinci07,
  ArenaVinci08,
  ArenaVinci10,
  ArenaVinci11,
  ArenaVinci12,
  ArenaVinci13,
  ArenaVinci14,
  ArenaVinci15,
  ArenaVinci16,
  ArenaVinci17,
  ArenaVinci18,
  ArenaVinci19,
  CampinasDecor01,
  CampinasDecor02,
  CampinasDecor03,
  CampinasDecor04,
  CampinasDecor05,
  CampinasDecor06,
  CampinasDecor07,
  CampinasDecor08,
  CampinasDecor09,
  CampinasDecor10,
  CampinasDecor11,
  CampinasDecor12,
  CampinasDecor13,
  CampinasDecor14,
  CampinasDecor15,
  CampinasDecor16,
  CampinasDecor17,
  CasaTwist01,
  CasaTwist02,
  CasaTwist03,
  CasaTwist04,
  CasaTwist05,
  CasaTwist06,
  CasaTwist07,
  CasaTwist08,
  CasaTwist09,
  CasaTwist10,
  CasaTwist11,
  CasaTwist12,
  CasaTwist13,
  CasaTwist14,
  CasaTwist15,
  CasaTwist16,
  CasaTwist17,
  CasaTwist18,
  CasaTwist19,
  CasaTwist20,
  CasaTwist21,
  CasaTwist22,
  CasaTwist23,
  CasaTwist24,
  CasaTwist25,
  CasaTwist26,
  CasaTwist27,
  CasaTwist28,
  CasaTwist29,
  CasaTwist30,
  CasaTwist31,
  CasaTwist32,
  CasaTwist33,
  CasaTwist34,
  CasaTwist35,
  CasaTwist36,
  CasaTwist37,
  CasaTwist38,
  CasaTwist39,
  CasaTwist40,
  CasaTwist41,
  CasaTwist42,
  CasaTwist43,
  CasaTwist44,
  CasaTwist45,
  CasaTwist46,
  CasaTwist47,
  CasaTwist48,
  CasaTwist49,
  CasaTwist50,
  CasaTwist51,
  CasaTwist52,
  CasaTwist53,
  CasaTwist54,
  CasaTwist55,
  CasaTwist56,
  CasaTwist57,
  CasaTwist58,
  CasaTwist59,
  CasaTwist60,
  CasaTwist61,
  CasaTwist62,
  CasaTwist63,
  CasaTwist64,
  CasaTwist65,
  CasaTwist66,
  CasaTwist67,
  CasaTwist68,
  CasaTwist69,
  CasaTwist70,
  CasaTwist71,
  CasaTwist72,
  CasaTwist73,
  CasaTwist74,
  CasaTwist75,
  CasaTwist76,
  CasaTwist77,
  CasaTwist78,
  CasaTwist79,
  CasaTwist80,
  CasaTwist81,
  CasaTwist82,
  CasaTwist83,
  CasaTwist84,
  CasaTwist85,
  CasaTwist86,
  CasaTwist87,
  CasaTwist88,
  CasaTwist89,
  CasaTwist90,
  CasaTwist91,
  CasaTwist92,
  ResidenciaAj01,
  ResidenciaAj02,
  ResidenciaAj03,
  ResidenciaAj04,
  ResidenciaAj05,
  ResidenciaAj06,
  ResidenciaAj07,
  ResidenciaAlta01,
  ResidenciaAlta02,
  ResidenciaAlta03,
  ResidenciaAlta04,
  ResidenciaAlta05,
  ResidenciaAlta06,
  ResidenciaAlta07,
  ResidenciaAlta08,
  ResidenciaAlta09,
  ResidenciaAlta10,
  ResidenciaColina01,
  ResidenciaColina02,
  ResidenciaColina03,
  ResidenciaColina04,
  ResidenciaColina05,
  ResidenciaColina06,
  ResidenciaColina07,
  ResidenciaColina08,
  ResidenciaColina09,
  ResidenciaColina10,
  ResidenciaColina11,
  ResidenciaColina12,
  ResidenciaColina13,
  ResidenciaColina14,
  ResidenciaColina15,
  ResidenciaColina16,
  ResidenciaColina17,
  ResidenciaColina18,
  ResidenciaColina19,
  ResidenciaColina20,
  ResidenciaColina21,
  ResidenciaColina22,
  ResidenciaColina23,
  ResidenciaColina24,
  ResidenciaColina25,
  ResidenciaColina26,
  ResidenciaColina27,
  ResidenciaColina28,
  ResidenciaColina29,
  ResidenciaColina30,
  ResidenciaColina31,
  ResidenciaColina32,
  ResidenciaColina33,
  ResidenciaColina34,
  ResidenciaColina35,
  ResidenciaDiroma01,
  ResidenciaDiroma010,
  ResidenciaDiroma011,
  ResidenciaDiroma012,
  ResidenciaDiroma013,
  ResidenciaDiroma014,
  ResidenciaDiroma015,
  ResidenciaDiroma02,
  ResidenciaDiroma03,
  ResidenciaDiroma04,
  ResidenciaDiroma05,
  ResidenciaDiroma06,
  ResidenciaDiroma07,
  ResidenciaDiroma08,
  ResidenciaDr01,
  ResidenciaDr02,
  ResidenciaDr03,
  ResidenciaDr04,
  ResidenciaDr05,
  ResidenciaDr06,
  ResidenciaDr07,
  ResidenciaDr08,
  ResidenciaDr09,
  ResidenciaDr10,
  ResidenciaDr11,
  ResidenciaDr12,
  ResidenciaDr13,
  ResidenciaDr14,
  ResidenciaDr15,
  ResidenciaDr16,
  ResidenciaDr17,
  ResidenciaELExterno01,
  ResidenciaELExterno02,
  ResidenciaELExterno03,
  ResidenciaELExterno04,
  ResidenciaELExterno05,
  ResidenciaELExterno06,
  ResidenciaELExterno07,
  ResidenciaELInterno01,
  ResidenciaELInterno010,
  ResidenciaELInterno011,
  ResidenciaELInterno012,
  ResidenciaELInterno013,
  ResidenciaELInterno014,
  ResidenciaELInterno015,
  ResidenciaELInterno016,
  ResidenciaELInterno017,
  ResidenciaELInterno018,
  ResidenciaELInterno019,
  ResidenciaELInterno02,
  ResidenciaELInterno020,
  ResidenciaELInterno03,
  ResidenciaELInterno04,
  ResidenciaELInterno05,
  ResidenciaELInterno06,
  ResidenciaELInterno07,
  ResidenciaELInterno08,
  ResidenciaELInterno09,
  ResidenciaGatti01,
  ResidenciaGatti02,
  ResidenciaGatti03,
  ResidenciaGatti04,
  ResidenciaGatti05,
  ResidenciaGatti06,
  ResidenciaGatti07,
  ResidenciaGatti08,
  ResidenciaHl01,
  ResidenciaHl02,
  ResidenciaHl03,
  ResidenciaHl04,
  ResidenciaHl05,
  ResidenciaHl06,
  ResidenciaHl07,
  ResidenciaHl08,
  ResidenciaHl09,
  ResidenciaHl10,
  ResidenciaHl11,
  ResidenciaJK01,
  ResidenciaJK010,
  ResidenciaJK011,
  ResidenciaJK012,
  ResidenciaJK013,
  ResidenciaJK02,
  ResidenciaJK03,
  ResidenciaJK04,
  ResidenciaJK05,
  ResidenciaJK06,
  ResidenciaJK07,
  ResidenciaJK08,
  ResidenciaJK09,
  ResidenciaManhatan01,
  ResidenciaManhatan010,
  ResidenciaManhatan02,
  ResidenciaManhatan03,
  ResidenciaManhatan04,
  ResidenciaManhatan05,
  ResidenciaManhatan06,
  // ResidenciaManhatan07,
  ResidenciaManhatan08,
  ResidenciaManhatan09,
  ResidenciaMartinelli01,
  ResidenciaMartinelli010,
  ResidenciaMartinelli011,
  ResidenciaMartinelli012,
  ResidenciaMartinelli013,
  ResidenciaMartinelli014,
  ResidenciaMartinelli015,
  ResidenciaMartinelli016,
  ResidenciaMartinelli017,
  ResidenciaMartinelli018,
  ResidenciaMartinelli02,
  ResidenciaMartinelli03,
  ResidenciaMartinelli04,
  ResidenciaMartinelli05,
  ResidenciaMartinelli06,
  ResidenciaMartinelli07,
  ResidenciaMartinelli08,
  ResidenciaMartinelli09,
  ResidenciaPrimavera01,
  ResidenciaPrimavera02,
  ResidenciaPrimavera03,
  ResidenciaPrimavera04,
  ResidenciaPrimavera05,
  ResidenciaPrimavera06,
  ResidenciaPrimavera07,
  ResidenciaPrimavera08,
  ResidenciaPrimavera09,
  ResidenciaRL01,
  ResidenciaRL02,
  ResidenciaRL03,
  ResidenciaRL04,
  ResidenciaRL05,
  ResidenciaRL06,
  ResidenciaRL07,
  ResidenciaRL08,
  ResidenciaSchiavon01,
  ResidenciaSchiavon010,
  ResidenciaSchiavon02,
  ResidenciaSchiavon03,
  ResidenciaSchiavon04,
  ResidenciaSchiavon05,
  ResidenciaSchiavon06,
  ResidenciaSchiavon07,
  ResidenciaSchiavon08,
  ResidenciaSchiavon09,
  ResidenciaTS01,
  ResidenciaTS010,
  ResidenciaTS02,
  ResidenciaTS03,
  ResidenciaTS04,
  ResidenciaTS05,
  ResidenciaTS06,
  ResidenciaTS07,
  ResidenciaTS08,
  ResidenciaTS09,

  ResidenciaYp01,
  ResidenciaYp02,
  ResidenciaYp03,
  ResidenciaYp04,
  ResidenciaYp05,
  ResidenciaYp06,
  ResidenciaYp07,
} from '~/assets/images';

export const data = [
  {
    image: ResidenciaColina01,
    title: 'RESIDÊNCIA COLINA',
    condominium: 'Condomínio Terra Cota - Indaiatuba',
    area: '',
    description: `
      Com uma vista incrível para a área verde, o grande diferencial dessa residência é a topografia em aclive, que proporcionou uma valorização no projeto e muita imponência.
      Para aproveitar todos os espaços a casa foi projetada em vários platôs, aumentando a sensação de amplitude.
      Para deixar a casa ampla e ventilada projetamos grandes vãos, integrando toda a residência.
    `,
    photos: [
      ResidenciaColina01,
      ResidenciaColina02,
      ResidenciaColina03,
      ResidenciaColina04,
      ResidenciaColina05,
      ResidenciaColina06,
      ResidenciaColina07,
      ResidenciaColina08,
      ResidenciaColina09,
      ResidenciaColina10,
      ResidenciaColina11,
      ResidenciaColina12,
      ResidenciaColina13,
      ResidenciaColina14,
      ResidenciaColina15,
      ResidenciaColina16,
      ResidenciaColina17,
      ResidenciaColina18,
      ResidenciaColina19,
      ResidenciaColina20,
      ResidenciaColina21,
      ResidenciaColina22,
      ResidenciaColina23,
      ResidenciaColina24,
      ResidenciaColina25,
      ResidenciaColina26,
      ResidenciaColina27,
      ResidenciaColina28,
      ResidenciaColina29,
      ResidenciaColina30,
      ResidenciaColina31,
      ResidenciaColina32,
      ResidenciaColina33,
      ResidenciaColina34,
      ResidenciaColina35,
    ],
  },
  {
    image: ResidenciaDr01,
    title: 'Residência DR',
    condominium: 'Condomínio Petrus - Indaiatuba',
    area: '',
    description: `
      Um projeto que celebra a integração com a natureza desde o primeiro olhar.
      A Residência RD foi implantada em um terreno privilegiado, onde o verde é protagonista. A volumetria contemporânea é marcada pela presença de materiais naturais como a pedra e a madeira, que criam um diálogo harmonioso com a vegetação exuberante ao redor.
      A fachada transmite imponência e acolhimento ao mesmo tempo — com destaque para o jardim vertical e o paisagismo que suavizam os limites entre a construção e o entorno natural. Aqui, arquitetura e paisagem se fundem para proporcionar uma experiência de morar conectada com o essencial.
    `,
    photos: [
      ResidenciaDr01,
      ResidenciaDr02,
      ResidenciaDr03,
      ResidenciaDr04,
      ResidenciaDr05,
      ResidenciaDr06,
      ResidenciaDr07,
      ResidenciaDr08,
      ResidenciaDr09,
      ResidenciaDr10,
      ResidenciaDr11,
      ResidenciaDr12,
      ResidenciaDr13,
      ResidenciaDr14,
      ResidenciaDr15,
      ResidenciaDr16,
      ResidenciaDr17,
    ],
  },
  {
    image: CasaTwist01,
    title: 'RESIDÊNCIA TWIST',
    condominium: 'Condomínio Maison Du Parc - Indaiatuba',
    area: '',
    description: `
      Todos os ambientes foram pensados em harmonia, priorizando elementos naturais. Os grandes vãos e o pé direito duplo conferem a sensação de amplitude, ventilação e uma boa iluminação natural que favorece o interior da residência.
      Para alcançar um visual contemporâneo, utilizamos elementos e peças com linhas retas que traduzem toda a beleza e elegância ao resultado. Tudo isso dentro de uma abordagem de design orientada para a família.
    `,
    photos: [
      CasaTwist01,
      CasaTwist02,
      CasaTwist03,
      CasaTwist04,
      CasaTwist05,
      CasaTwist06,
      CasaTwist07,
      CasaTwist08,
      CasaTwist09,
      CasaTwist10,
      CasaTwist11,
      CasaTwist12,
      CasaTwist13,
      CasaTwist14,
      CasaTwist15,
      CasaTwist16,
      CasaTwist17,
      CasaTwist18,
      CasaTwist19,
      CasaTwist20,
      CasaTwist21,
      CasaTwist22,
      CasaTwist23,
      CasaTwist24,
      CasaTwist25,
      CasaTwist26,
      CasaTwist27,
      CasaTwist28,
      CasaTwist29,
      CasaTwist30,
      CasaTwist31,
      CasaTwist32,
      CasaTwist33,
      CasaTwist34,
      CasaTwist35,
      CasaTwist36,
      CasaTwist37,
      CasaTwist38,
      CasaTwist39,
      CasaTwist40,
      CasaTwist41,
      CasaTwist42,
      CasaTwist43,
      CasaTwist44,
      CasaTwist45,
      CasaTwist46,
      CasaTwist47,
      CasaTwist48,
      CasaTwist49,
      CasaTwist50,
      CasaTwist51,
      CasaTwist52,
      CasaTwist53,
      CasaTwist54,
      CasaTwist55,
      CasaTwist56,
      CasaTwist57,
      CasaTwist58,
      CasaTwist59,
      CasaTwist60,
      CasaTwist61,
      CasaTwist62,
      CasaTwist63,
      CasaTwist64,
      CasaTwist65,
      CasaTwist66,
      CasaTwist67,
      CasaTwist68,
      CasaTwist69,
      CasaTwist70,
      CasaTwist71,
      CasaTwist72,
      CasaTwist73,
      CasaTwist74,
      CasaTwist75,
      CasaTwist76,
      CasaTwist77,
      CasaTwist78,
      CasaTwist79,
      CasaTwist80,
      CasaTwist81,
      CasaTwist82,
      CasaTwist83,
      CasaTwist84,
      CasaTwist85,
      CasaTwist86,
      CasaTwist87,
      CasaTwist88,
      CasaTwist89,
      CasaTwist90,
      CasaTwist91,
      CasaTwist92,
      ResidenciaAlta01,
      ResidenciaAlta02,
      ResidenciaAlta03,
      ResidenciaAlta04,
      ResidenciaAlta05,
      ResidenciaAlta06,
      ResidenciaAlta07,
      ResidenciaAlta08,
      ResidenciaAlta09,
      ResidenciaAlta10,
    ],
  },
  {
    image: CampinasDecor02,
    title: 'CAMPINAS DECOR 2024',
    condominium: 'Campinas Decor 2024 — Dormitório do Huan',
    area: '',
    description: `
      Nesta edição da Campinas Decor 2024, tive o prazer de assinar o dormitório de um adolescente de 16 anos, o Huan — um jovem cheio de personalidade, apaixonado por histórias que envolvem os trilhos do trem e o charme rústico das antigas estações ferroviárias.
      A proposta foi criar um quarto com identidade masculina forte, mas que ao mesmo tempo fosse acolhedor, funcional e cheio de estilo. Apostamos em materiais atemporais, como a madeira natural, o tijolinho à vista e estruturas metálicas marcantes, que juntos evocam a força e a nostalgia das ferrovias. Cada detalhe remete à robustez e ao espírito aventureiro de quem ama trilhos e viagens.
      A iluminação aconchegante completa a atmosfera do espaço, com pontos estrategicamente posicionados para criar um ambiente propício ao descanso, à concentração e ao lazer. O resultado é um quarto que traduz a essência de um jovem contemporâneo, que valoriza suas raízes e carrega consigo um olhar curioso sobre o mundo.
      Esse projeto foi um convite à criatividade, à memória afetiva e à liberdade de sonhar. Foi um privilégio transformar esse universo em forma de espaço.
    `,
    photos: [
      CampinasDecor01,
      CampinasDecor02,
      CampinasDecor03,
      CampinasDecor04,
      CampinasDecor05,
      CampinasDecor06,
      CampinasDecor07,
      CampinasDecor08,
      CampinasDecor09,
      CampinasDecor10,
      CampinasDecor11,
      CampinasDecor12,
      CampinasDecor13,
      CampinasDecor14,
      CampinasDecor15,
      CampinasDecor16,
      CampinasDecor17,
    ],
  },
  {
    image: ResidenciaYp01,
    title: 'Residência YP',
    condominium: 'condomínio London Park - Indaiatuba',
    area: '',
    description: `
      Residência YP – Arquitetura contemporânea em equilíbrio com o essencial.
      Localizada no condomínio London Park, em Indaiatuba (SP), a Residência YP é um projeto que traduz a essência do morar contemporâneo com sofisticação, fluidez e acolhimento.
      Com volumes bem definidos e materiais naturais em destaque, a fachada revela o equilíbrio entre o concreto, a madeira ripada e elementos vazados, que não apenas compõem a estética, mas também favorecem ventilação e luminosidade naturais.
      A área social foi pensada para integrar os ambientes internos e externos de maneira fluida: sala, cozinha gourmet e piscina se conectam por grandes esquadrias em vidro piso-teto, trazendo leveza e reforçando a conexão com o paisagismo.
      Na paleta, tons neutros e texturas naturais se equilibram com o uso estratégico de cobogós e painéis ripados, criando profundidade e identidade visual. O projeto de interiores segue a mesma linguagem: ambientes iluminados, funcionais e com acabamentos atemporais.
      A Residência YP é um convite à contemplação, ao convívio e à experiência de um lar que respeita o tempo, a luz e a vida.
    `,
    photos: [
      ResidenciaYp01,
      ResidenciaYp02,
      ResidenciaYp03,
      ResidenciaYp04,
      ResidenciaYp05,
      ResidenciaYp06,
      ResidenciaYp07,
    ],
  },
  {
    image: ResidenciaAj01,
    title: 'Residência AJ',
    condominium: 'Residência AJ - Indaiatuba',
    area: '',
    description: `
      Ambientes que se conectam para celebrar os encontros.
      Nesta cozinha da Residência AJ, funcionalidade e estética caminham juntas. A ilha central em quartzo branco com veios delicados recebe os convidados com elegância, enquanto a marcenaria em madeira aquece o espaço e contrasta com a parede de tijolos aparentes que abriga a adega — um detalhe que traz personalidade e charme.
      A integração com a sala de jantar valoriza o convívio, criando um ambiente acolhedor e contemporâneo, onde cada elemento foi pensado para tornar a experiência de estar em casa ainda mais especial.
    `,
    photos: [
      ResidenciaAj01,
      ResidenciaAj02,
      ResidenciaAj03,
      ResidenciaAj04,
      ResidenciaAj05,
      ResidenciaAj06,
      ResidenciaAj07,
    ],
  },
  {
    image: ResidenciaHl01,
    title: 'Residência HL',
    condominium: 'Apartamento Le Jardin - Indaiatuba',
    area: '',
    description: `
    Localizado em um dos condomínios mais desejados de Indaiatuba, o Le Jardin, este apartamento foi pensado para traduzir charme, funcionalidade e estilo em cada detalhe.
    A integração dos espaços sociais revela um projeto contemporâneo, com materiais atemporais e uma paleta que equilibra tons naturais, madeira e toques de preto, criando uma atmosfera acolhedora e sofisticada. A área gourmet é um dos destaques, com marcenaria bem planejada, metais de alta qualidade e uma composição que mistura linhas retas, estruturas metálicas e iluminação suave, ideal para receber amigos e familiares com conforto.
    Na cozinha, o charme fica por conta do tom azul profundo nos armários, que contrasta com o granilite escuro das paredes e a leveza do piso claro, criando um ambiente cheio de personalidade. As prateleiras metálicas com madeira natural reforçam a estética industrial chic, valorizando o aproveitamento vertical e a funcionalidade.
    O ambiente de jantar recebe a luz natural de forma fluida, com cortinas translúcidas que suavizam o espaço e uma luminária escultural que funciona como ponto focal sobre a mesa redonda. Toda a composição valoriza o convívio, o design e o bem-estar.
    Este projeto é a tradução perfeita de um lar que une estilo contemporâneo, conforto e praticidade, ideal para quem busca viver bem com elegância em um dos endereços mais especiais de Indaiatuba.
    `,
    photos: [
      ResidenciaHl01,
      ResidenciaHl02,
      ResidenciaHl03,
      ResidenciaHl04,
      ResidenciaHl05,
      ResidenciaHl06,
      ResidenciaHl07,
      ResidenciaHl08,
      ResidenciaHl09,
      ResidenciaHl10,
      ResidenciaHl11,
    ],
  },
  {
    image: ResidenciaManhatan01,
    title: 'RESIDÊNCIA MANHATAN',
    condominium: 'Edifício Manhathan - Indaiatuba',
    area: '',
    description: `
      Todos os ambientes foram projetados e pensados para o dia a dia dos moradores. Utilizamos painéis em madeira e peças decorativas confortáveis e arrojadas, que deram todo o conforto e acolhimento em cada local.
      Para ampliar os ambientes utilizamos os jogos de espelhos, valorizando a decoração.
    `,
    isMobilePhoto: true,
    photos: [
      ResidenciaManhatan02,
      ResidenciaManhatan03,
      ResidenciaManhatan04,
      ResidenciaManhatan05,
      ResidenciaManhatan06,
      // ResidenciaManhatan07,
      ResidenciaManhatan08,
      ResidenciaManhatan09,
      ResidenciaManhatan010,
    ],
  },
  {
    image: ResidenciaDiroma010,
    title: 'RESIDÊNCIA DI ROMA',
    condominium: 'Condomínio Di Roma - Indaiatuba',
    area: '',
    description: `
    Essa residência tem uma área social totalmente integrada e funcional, dando amplitude nos espaços e trazendo um conforto diferenciado.
    Priorizamos muitos elementos naturais como a composição da pedra com a madeira.
    `,
    isMobilePhoto: true,
    photos: [
      ResidenciaDiroma01,
      ResidenciaDiroma02,
      ResidenciaDiroma03,
      ResidenciaDiroma04,
      ResidenciaDiroma05,
      ResidenciaDiroma06,
      ResidenciaDiroma07,
      ResidenciaDiroma08,
      // ResidenciaDiroma09,
      ResidenciaDiroma011,
      ResidenciaDiroma012,
      ResidenciaDiroma013,
      ResidenciaDiroma014,
      ResidenciaDiroma015,
    ],
  },
  {
    image: ResidenciaELExterno01,
    title: 'RESIDÊNCIA EL',
    condominium: 'Condomínio Villa dos Pinheiros – Indaiatuba - SP',
    area: '',
    description: `
      A casa foi projetada para ter a integração dos ambientes sociais voltadas para a piscina e para uma linda área verde. Os elementos e matérias naturais valorizaram muito a estética da casa.
      A decoração também segue o mesmo estilo contemporâneo, com linhas retas, muitos elementos naturais e peças de designers brasileiros que focam na funcionalidade, praticidade e conforto.
    `,
    photos: [
      ResidenciaELExterno02,
      ResidenciaELExterno03,
      ResidenciaELExterno04,
      ResidenciaELExterno05,
      ResidenciaELExterno06,
      ResidenciaELExterno07,
      ResidenciaELInterno01,
      ResidenciaELInterno02,
      ResidenciaELInterno03,
      ResidenciaELInterno04,
      ResidenciaELInterno05,
      ResidenciaELInterno06,
      ResidenciaELInterno07,
      ResidenciaELInterno08,
      ResidenciaELInterno09,
      ResidenciaELInterno010,
      ResidenciaELInterno011,
      ResidenciaELInterno012,
      ResidenciaELInterno013,
      ResidenciaELInterno014,
      ResidenciaELInterno015,
      ResidenciaELInterno016,
      ResidenciaELInterno017,
      ResidenciaELInterno018,
      ResidenciaELInterno019,
      ResidenciaELInterno020,
    ],
  },
  {
    image: ResidenciaGatti01,
    title: 'RESIDÊNCIA GATTI',
    condominium: 'Condomínio Jardim Primavera III – Salto - SP',
    area: '',
    description: `
    Com uma estrutura construtiva mista em alvenaria e estrutura metálica, essa casa confere um toque totalmente moderno e sustentável. A Arquitetura proporcionou muitos ambientes especiais.
    Para deixar o projeto ainda mais especial, essa residência contempla um lago artificial, totalmente sustentável, integrado à área gourmet.
    `,
    photos: [
      ResidenciaGatti02,
      ResidenciaGatti03,
      ResidenciaGatti04,
      ResidenciaGatti05,
      ResidenciaGatti06,
      ResidenciaGatti07,
      ResidenciaGatti08,
    ],
  },
  {
    image: ResidenciaJK02,
    title: 'RESIDÊNCIA JK',
    condominium: 'Condomínio Helvetia Park - Indaiatuba',
    area: '',
    description: `
      Essa linda residência possui uma fachada incrível e moderna. A casa foi projetada para o bem-estar e funcionalidade, com ambientes versáteis e integrados. A estrutura metálica, pedra natural e brises fazem uma composição harmônica na fachada.
      Aproveitamos todas as curvas de níveis do terreno, deixando a residência alta e proporcionando uma vista privilegiada.
      A área gourmet foi integrada com todos os ambientes sociais, voltada para uma vista incrível, transformando o espaço em uma área confortável para reunir a família e os amigos.
    `,
    photos: [
      ResidenciaJK01,
      ResidenciaJK03,
      ResidenciaJK04,
      ResidenciaJK05,
      ResidenciaJK06,
      ResidenciaJK07,
      ResidenciaJK08,
      ResidenciaJK09,
      ResidenciaJK010,
      ResidenciaJK011,
      ResidenciaJK012,
      ResidenciaJK013,
    ],
  },
  {
    image: ResidenciaPrimavera04,
    title: 'RESIDÊNCIA PRIMAVERA',
    condominium: 'Condomínio Primavera - Salto',
    area: '',
    description: `
      Uma casa moderna com uma fachada imponente, os vidros e a estrutura metálica proporcionaram leveza a estética da residência. O terreno amplo proporcionou um belo paisagismo valorizando todos os espaços e vistas.
    `,
    photos: [
      ResidenciaPrimavera01,
      ResidenciaPrimavera02,
      ResidenciaPrimavera03,
      ResidenciaPrimavera04,
      ResidenciaPrimavera05,
      ResidenciaPrimavera06,
      ResidenciaPrimavera07,
      ResidenciaPrimavera08,
      ResidenciaPrimavera09,
    ],
  },
  {
    image: ResidenciaRL01,
    title: 'RESIDÊNCIA RL',
    condominium: 'Condomínio Terra Cota - Indaiatuba',
    area: '',
    description: `
      Residência contemporânea, com grandes aberturas e materiais naturais. O grande desafio foi otimizar vários espaços especiais em um terreno de 6m de declive, por esse motivo a casa tem uma estica alta e imponente.
      Para aproveitar as curvas do terreno, projetamos um sobrado invertido com a área social no pavimento inferior. A casa tem uma estética alta proporcionando uma vista linda para a área verde do condomínio.
    `,
    photos: [
      ResidenciaRL02,
      ResidenciaRL03,
      ResidenciaRL04,
      ResidenciaRL05,
      ResidenciaRL06,
      ResidenciaRL07,
      ResidenciaRL08,
    ],
  },
  {
    image: ResidenciaSchiavon01,
    title: 'RESIDÊNCIA SCHIAVON',
    condominium: 'London Park - Indaiatuba',
    area: '',
    description: `
      Com uma fachada grande e imponente, utilizamos elementos com linhas retas e materiais naturais, os brises desenvolvem um papel importante na fachada, dando proteção ao sol da tarde.
      A área social é totalmente integrada com a cozinha, sala e gourmet, otimizando os espaços e modernizando a estética final.
    `,
    photos: [
      ResidenciaSchiavon02,
      ResidenciaSchiavon03,
      ResidenciaSchiavon04,
      ResidenciaSchiavon05,
      ResidenciaSchiavon06,
      ResidenciaSchiavon07,
      ResidenciaSchiavon08,
      ResidenciaSchiavon09,
      ResidenciaSchiavon010,
    ],
  },
  {
    image: ResidenciaTS01,
    title: 'RESIDÊNCIA TS',
    condominium: 'Condomínio terracota - Indaiatuba',
    area: '',
    description: `
      Projetamos essa residência com estruturas mistas como alvenaria e uma estrutura metálica dando uma leveza na estética e permitindo grandes vãos.  Grande parte da residência foi pensada no bem-estar da família e no conforto térmico e acústico.
      O grande diferencial desse projeto é a cobertura metálica inclinada, valorizando as formas e dando uma volumetria diferenciada.
    `,
    photos: [
      ResidenciaTS02,
      ResidenciaTS03,
      ResidenciaTS04,
      ResidenciaTS05,
      ResidenciaTS06,
      ResidenciaTS07,
      ResidenciaTS08,
      ResidenciaTS09,
      ResidenciaTS010,
    ],
  },


  {
    image: ResidenciaMartinelli03,
    title: 'RESIDÊNCIA MATANELLI',
    condominium: 'Condomínio Amistalden - Indaiatuba',
    area: '',
    description: `
      Residência com uma estética clean e moderna, esse projeto foi pensado na funcionalidade e no bem-estar da família.
      A integração da área gourmet com a cozinha proporcionou uma bancada em ilha integrada, atendendo a demanda da família que gosta de receber os amigos. Na área externa, mantemos tons quentes e para criar espaços especiais o pergolado em madeira, expressando charme e elegância.
    `,
    photos: [
      ResidenciaMartinelli01,
      ResidenciaMartinelli02,
      ResidenciaMartinelli03,
      ResidenciaMartinelli04,
      ResidenciaMartinelli05,
      ResidenciaMartinelli06,
      ResidenciaMartinelli07,
      ResidenciaMartinelli08,
      ResidenciaMartinelli09,
      ResidenciaMartinelli010,
      ResidenciaMartinelli011,
      ResidenciaMartinelli012,
      ResidenciaMartinelli013,
      ResidenciaMartinelli014,
      ResidenciaMartinelli015,
      ResidenciaMartinelli016,
      ResidenciaMartinelli017,
      ResidenciaMartinelli018,
    ],
  },
  {
    image: ArenaVinci01,
    title: 'ARENA VINCI',
    condominium: 'Arena Vinci – Campinas, SP',
    area: '',
    description: `
    Um espaço de esporte pensado para ir além da prática física — a Arena Vinci é um convite ao bem-estar, à conexão com a natureza e à arquitetura contemporânea.

    Localizada em Campinas, ela se destaca pela sua estrutura metálica leve e elegante, combinada a elementos atemporais que trazem equilíbrio entre o moderno e o acolhedor. A grande protagonista do cenário é a vista: uma área verde exuberante que emoldura o espaço e transforma cada treino em uma experiência inspiradora.

    Mais do que um lugar para o corpo, a Arena é um refúgio para a mente e os sentidos.

    `,
    isMobilePhoto: true,
    photos: [
      ArenaVinci02,
      ArenaVinci03,
      ArenaVinci04,
      ArenaVinci07,
      ArenaVinci05,
      ArenaVinci06,
      ArenaVinci08,
      ArenaVinci10,
      ArenaVinci11,
      ArenaVinci13,
      ArenaVinci12,
      ArenaVinci14,
      ArenaVinci15,
      ArenaVinci16,
      ArenaVinci17,
      ArenaVinci18,
      ArenaVinci19,
    ],
  },
];
